import axios from "axios";
import {authHeader} from "@/services/auth-header";
import {handleResponse} from "@/services/user.service";
import router from "@/main";
import {longAsStringDate} from "@/services/utils";

export const Axios = axios;

Axios.defaults.headers = authHeader();

Axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        localStorage.setItem('user', '');
        localStorage.setItem('jwt', '');
        localStorage.setItem('jwt_life_time', '');
        router.push('/login');
    }
});

var downloadingModal;

const selectors =
    {
        archived:
            [{name: "Активные", value: "null"},
                {name: "В архиве", value: "notNull"},
                {name: "Все", value: "all"}]
    }

export const Repo = {getPage, getAll, getAllHeavy, get, save, saveByLink, uploadFile, downloadFile, getByURL, getSelector, deleteObject, killObject}

async function getPage(pageProperties, list, type) {
    await callDownloadingModal();
    return await Axios
        .post('/api/'+ type +'/page', pageProperties)
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            data.forEach(item => list.push({object: item, id: item.id}));
        })
        .catch(e => {
            closeDownloadingModal();
        })
}

async function getAll(list, type) {
    await callDownloadingModal();
    await Axios
        .get('/api/'+ type +'/all')
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            data.forEach(item => list.push(item));
        })
        .catch(e => {
            closeDownloadingModal();
        })
}

async function getAllHeavy(list, type) {
    await callDownloadingModal();
    await Axios
        .get('/api/'+ type +'/all')
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            data.forEach(item => list.push({object: item, id: item.id}));
        })
        .catch(e => {
            closeDownloadingModal();
        })
}

async function get(id, type) {
    await callDownloadingModal();
    return await Axios
        .get('/api/' + type + '/' + id)
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            return data;
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        });
}

async function getByURL(url) {
    await callDownloadingModal();
    return await Axios
        .get('/api/' + url)
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            return data;
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        })
}

async function save(object, type) {
    await callDownloadingModal();
    return await Axios
        .post('/api/' + type + '/', object)
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            return data;
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        })
}

async function saveByLink(object, link) {
    await callDownloadingModal();
    return await Axios
        .post('api/' + link, object)
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            return data;
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        })
}

async function uploadFile(url, formData) {
    await callDownloadingModal();
    return await Axios
        .post('/api/' + url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            return data;
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        })
}

async function downloadFile(url, fileName) {
    await callDownloadingModal();
    let anchor = document.createElement("a");
    let headers = authHeader();
    await fetch('/api/' + url, {headers})
        .then(response => response.blob())
        .then(blobby => {
            closeDownloadingModal()
            let objectUrl = window.URL.createObjectURL(blobby);
            anchor.href = objectUrl;
            anchor.download = fileName;
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        });
}

async function deleteObject(object, type) {
    await callDownloadingModal();
    return await Axios
        .delete('/api/' + type +'/' + object.id)
        .then(handleResponse)
        .then(data => {
            closeDownloadingModal();
            return data;
        })
        .catch(e => {
            closeDownloadingModal();
            return null;
        })
}

async function killObject(object, type) {
    if (window.confirm('Точно удаляем?')) {
        sleep(1000);
        if(window.confirm('Точно? Операция не обратима')) {
            await callDownloadingModal();
            return await Axios
                .delete('/api/admin/' + type +'/' + object.id)
                .then(handleResponse)
                .then(data => {
                    closeDownloadingModal();
                    return data;
                }).catch(e => {
                    closeDownloadingModal();
                    return false;
                })
        }
    }
    return false;
}

async function getSelector(name) {
    if (name === 'users') {
        let users = await getByURL('admin/users');
        let rsl = [{name: "Все", value: "all"}];
        users.forEach(user => {
            rsl.push({name: user.name, value: user.id})
        });
        return rsl;
    } else if (name === 'entities_types') {
        let entities = await getByURL('admin/entities_types');
        let rsl = [{name: "Всем", value: "all"}];
        entities.forEach(entity => {
            rsl.push({name: entity, value: entity})
        });
        return rsl;
    } else if (name.includes('/')){
        let entities = await getByURL(name);
        let rsl = [];
        entities.forEach(entity => {
            rsl.push({name: entity, value: entity})
        });
        return rsl;
    }
    return selectors[name];
}

async function callDownloadingModal() {
    if (!downloadingModal) {
        downloadingModal = await document.getElementById('DOWNLOADING_MODAL');
    }
    if (downloadingModal) {
        downloadingModal.style.display = "block";
    }
}

async function closeDownloadingModal() {
    if (downloadingModal) {
        downloadingModal.style.display = "none";
    }
}

function sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
}